import { createFileRoute } from '@tanstack/react-router';
import { CircularRegister } from '@/features/circulars/CircularRegister';

/* Il registro di chi scrive, rivede e pubblica (task 2055). `?new=1` apre il form: ci porta il
   vecchio indirizzo di «Invia comunicazioni». `?open=` apre una circolare: ci portano gli avvisi di
   revisione, approvazione e sollecito (task 2062). */
export const Route = createFileRoute('/_app/circulars/register')({
  component: CircularRegisterRoute,
  validateSearch: (s: Record<string, unknown>): { new?: boolean; open?: string } => ({
    ...(s.new ? { new: true } : {}),
    ...(typeof s.open === 'string' && s.open ? { open: s.open } : {}),
  }),
});

function CircularRegisterRoute() {
  const search = Route.useSearch();
  return <CircularRegister initialNew={search.new === true} openId={search.open ?? null} />;
}
